import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Platform, ScrollView, Dimensions } from 'react-native';
import BannerPrincipal from '../Body/Banners/BannerPrincipal';
import BannerBancario from '../Body/Banners/BannerBancario';
import BannersDuales from '../Body/Banners/BannersDuales';
import BannerOfertasEspeciales from '../Body/Banners/BannerOfertasEspeciales';
import BannerInferior from '../Body/Banners/BannerInferior';
import FormularioContacto from './FormularioContacto';
import BannerManager from '../../../components/BannerManager';
import { colores, layout } from '../../../styles/variablesCss';
import BannerBancarioWeb from '../Body/Banners/BannerBancarioWeb';

const Home = () => {
  const [windowWidth, setWindowWidth] = useState(Dimensions.get('window').width);
  const isSmallWeb = Platform.OS === 'web' && windowWidth < 768;

  useEffect(() => {
    const updateLayout = ({ window }) => setWindowWidth(window.width);
    const subscription = Dimensions.addEventListener('change', updateLayout);
    return () => {
      if (subscription?.remove) {
        subscription.remove();
      } else if (typeof Dimensions.removeEventListener === 'function') {
        Dimensions.removeEventListener('change', updateLayout);
      }
    };
  }, []);

  return (
    <BannerManager>
      <View style={styles.mainContainer}>
        <ScrollView contentContainerStyle={styles.scrollContent}>
          <View style={[
            styles.contentContainer,
            isSmallWeb && styles.contentContainerMobile
          ]}>
            <BannerPrincipal />
            {/*<BannerBancario />*/}
            <BannerBancarioWeb />
            {/* Nuevo componente BannerProductos con carga desde API */}
            { /*(() => {
              try {
                return (
                  <BannerProductos 
                    title="Productos Destacados" 
                    onVerMas={handleVerMasDestacados} 
                  />
                );
              } catch (error) {
                console.error('Error en BannerProductos:', error);
                return null;
              }
            })()*/}
            {/* Componente BannersDuales */}
            <BannersDuales />
            <BannerOfertasEspeciales />
            <BannerInferior />
            <FormularioContacto />
            {/*<View style={styles.buttonsContainer}>
              <TouchableOpacity
                style={styles.payButton}
                onPress={() => navigation.navigate('Pagar')}
              >
                <Text style={styles.payButtonText}>Ir a Pagar</Text>
              </TouchableOpacity>
            </View>*/}
          </View>

        </ScrollView>
        
      </View>
    </BannerManager>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: colores.fondo,
    marginTop: Platform.OS === 'web' ? 2 : 0,
  },
  scrollContent: {
    flexGrow: 1,
    paddingTop: 0, // Quitamos el paddingTop ya que se maneja desde App.js
  },
  contentContainer: {
    width: '100%',
    paddingHorizontal: layout.contentPadding,
    paddingTop: 0,
    marginTop: Platform.OS === 'web' ? 0 : 0,
  },
  contentContainerMobile: {
    paddingHorizontal: layout.contentPaddingMobile,
  },
});

export default Home;
